import React from 'react';
import { EarthCard, EarthText } from '../../components';

export default () => (
  <EarthCard>
    <EarthText size='xlarge' fontStyle='bold'>Instructions</EarthText>
    <div className='divider mb-4'/>
    <EarthText>Instructions has not been set yet.</EarthText>
  </EarthCard>
)